/**
 * Booking API
 *
 * Contact: support@xenoncloud.net
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export type OrderStatus = 'PENDING' | 'PAID' | 'EXPIRED' | 'CANCELED';

export const OrderStatus = {
  PENDING: 'PENDING' as OrderStatus,
  PAID: 'PAID' as OrderStatus,
  EXPIRED: 'EXPIRED' as OrderStatus,
  CANCELED: 'CANCELED' as OrderStatus
};
